import React, { useContext } from 'react';
import {
  PiccolaComposableBanner as PiccolaComposableBannerComponent
} from '@thd-olt-component-react/internal-marketing-banner';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { string } from 'prop-types';
import { HomepageContext } from './context/HomepageContext';

export function PiccolaComposableBanner({ id }) {
  const { isB2C } = useContext(HomepageContext);

  return (
    <ErrorBoundary name="internal-marketing-banner-piccola-composable">
      <QueryProvider key={id} cacheKey={id}>
        <PiccolaComposableBannerComponent
          componentId={id}
          componentClass="PiccolaComposableBanner"
          enableB2CRadius={isB2C}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

PiccolaComposableBanner.propTypes = {
  id: string.isRequired
};

PiccolaComposableBanner.defaultProps = {};
